export const numberWith2Decimals = /^[0-9]+(\.[0-9]{1,2})?$/

/**
 * 
 * @param {number} value 
 * @param {number} decimalPlaces 
 * @returns original number fixed to n digits
 */
export const toDecimals = (value, decimalPlaces) => {
  // ValidazioneDF
  // Sostituzione di virgole con punti
  const normalizedValue = value.replace(/,/g, '.');

  // Questa regex si abbina ad una stringa composta da cifre numeriche con la possibilità di avere fino a due cifre decimali dopo il punto.
  const regex = new RegExp(`^[0-9]+(\\.[0-9]{1,${decimalPlaces}})?$`);
  const isValid = regex.test(normalizedValue);

  if (isValid) {
    // Questa regex è utile per identificare gli zeri iniziali che sono seguiti da altri numeri in una stringa, ma senza includere nel match i numeri che seguono lo zero. 
    return normalizedValue.replace(/^0(?=\d)/g, "");
  }
  return 0
}

export const toTwoDecimals = (value) => {
  // ValidazioneDF
  // Sostituzione di virgole con punti
  const normalizedValue = value.replace(/,/g, '.').replace(/^0(?=\d)/g, "");

  // Questa regex si abbina ad una stringa composta da cifre numeriche con la possibilità di avere fino a due cifre decimali dopo il punto.
  const isValid = /^[0-9]+(\.[0-9]{1,2})?$/.test(normalizedValue);

  // Questa regex è utile per identificare gli zeri iniziali che sono seguiti da altri numeri in una stringa, ma senza includere nel match i numeri che seguono lo zero. 
  return normalizedValue.replace(/^0(?=\d)/g, "");
}

export const toZeroDecimals = (value) => {
  const normalizedValue = value.replace(/,/g, '.').replace(/[^0-9]*/g, '')
  const isValid = /\d/.test(normalizedValue);
  if (isValid) return normalizedValue.replace(/^0(?=\d)/g, "");
  return 0
}



// ADA-107 - Modifica approvazione PFE/CR: controlli adottati per campo note (testo email)

export const sanitizationPatterns = {
    // XSS Protection - Rimuove tag HTML e script
    // Cattura qualsiasi tag HTML: <tagname attributi>contenuto</tagname> o <tagname />
    htmlTags: /<[^>]*>/g,
    
    // Cattura specificamente tag script completi con tutto il contenuto interno
    // Esempio: <script>alert('xss')</script> o <script src="malicious.js"></script>
    scriptTags: /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
    
    // Rimuove event handlers JavaScript inline
    // Cattura pattern come: onclick=, onerror=, onload=, etc.
    // L'uguale può essere preceduto da spazi: onclick =, on click  =
    eventHandlers: /on\w+\s*=/gi,
    
    // Rimuove protocolli pericolosi e il contenuto che segue fino al prossimo spazio
    // Cattura: javascript:void(0), data:text/html,<script>, vbscript:msgbox
    // Il \S* cattura tutti i caratteri non-spazio che seguono il protocollo
    dangerousProtocols: /(javascript|data|vbscript):\S*/gi,
    
    // Rimuove funzioni JavaScript pericolose comunemente usate in attacchi XSS
    // alert(): mostra popup (usato per testare XSS)
    // eval(): esegue codice JavaScript arbitrario
    // Function(): crea nuove funzioni da stringhe
    // setTimeout/setInterval: eseguono codice in modo asincrono
    // Cattura la funzione e tutto il contenuto tra parentesi: alert('qualsiasi cosa qui')
    dangerousJsFunctions: /(alert|eval|Function|setTimeout|setInterval)\s*\([^)]*\)/gi,
    
    // Rimuove chiamate a funzioni che sembrano malevole
    // Cattura qualsiasi identificatore seguito da parentesi se contiene "hack", "malicious", "exploit", etc.
    // Esempio: maliciousFunction(), hack(), exploitCode()
    suspiciousFunctionCalls: /\b(hack|malicious|exploit|inject|payload|attack)\w*\s*\([^)]*\)/gi,
    
    // Caratteri di controllo pericolosi (mantiene \t, \n, \r che sono legittimi)
    // \x00-\x08: caratteri di controllo NULL e backspace
    // \x0B: vertical tab
    // \x0C: form feed
    // \x0E-\x1F: altri caratteri di controllo
    // \x7F: DELETE
    controlChars: /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g,
    
    // Pulizia estetica: riduce spazi multipli a massimo 2 spazi consecutivi
    // "text    with    spaces" → "text  with  spaces"
    multipleSpaces: /\s{3,}/g,
    
    // Pulizia estetica: riduce newline multiple a massimo 3 newline consecutive
    // Permette paragrafi separati ma previene spam di righe vuote
    multipleNewlines: /\n{4,}/g
};

/**
 * Sanitizza il testo delle note rimuovendo contenuti potenzialmente pericolosi
 * 
 * Questa funzione applica una serie di filtri per proteggere da:
 * - Cross-Site Scripting (XSS)
 * - Injection di codice JavaScript
 * - Event handlers malevoli
 * - Protocolli pericolosi
 * - Caratteri di controllo
 * 
 * @param {string} text - Il testo da sanitizzare
 * @returns {string} - Il testo sanitizzato e sicuro
 */
export const sanitizeNoteText = (text) => {
    if (!text) return '';
    
    let sanitized = text;
    
    // FASE 1: Rimozione tag HTML e script
    // Prima rimuoviamo i tag script completi (con il loro contenuto)
    sanitized = sanitized.replace(sanitizationPatterns.scriptTags, '');
    // Poi rimuoviamo tutti gli altri tag HTML
    sanitized = sanitized.replace(sanitizationPatterns.htmlTags, '');
    
    // FASE 2: Rimozione protocolli pericolosi e loro contenuto
    // Deve essere eseguito prima di rimuovere le funzioni JS
    sanitized = sanitized.replace(sanitizationPatterns.dangerousProtocols, '');
    
    // FASE 3: Rimozione funzioni JavaScript pericolose
    // Rimuove chiamate a funzioni come alert(), eval(), etc.
    sanitized = sanitized.replace(sanitizationPatterns.dangerousJsFunctions, '');
    
    // FASE 4: Rimozione chiamate a funzioni sospette
    // Rimuove funzioni con nomi che suggeriscono intenti malevoli
    sanitized = sanitized.replace(sanitizationPatterns.suspiciousFunctionCalls, '');
    
    // FASE 5: Rimozione event handlers
    // Rimuove attributi JavaScript inline come onclick=, onerror=
    sanitized = sanitized.replace(sanitizationPatterns.eventHandlers, '');
    
    // FASE 6: Rimozione caratteri di controllo
    // Elimina caratteri non stampabili che potrebbero causare problemi
    sanitized = sanitized.replace(sanitizationPatterns.controlChars, '');
    
    // FASE 7: Pulizia estetica
    // Normalizza spazi e newline multiple per una migliore leggibilità
    sanitized = sanitized.replace(sanitizationPatterns.multipleSpaces, '  ');
    sanitized = sanitized.replace(sanitizationPatterns.multipleNewlines, '\n\n\n');
    
    // FASE 8: Pulizia finale
    // Rimuove spazi all'inizio e alla fine del testo
    return sanitized.trim();
};

// ADA-107 - Modifica approvazione PFE/CR: controlli adottati per campo note (testo email)
